import React, { useEffect, useState, useMemo } from 'react';
import Trans from '../../components/translation/trans';
import useTranslation from '../../hooks/use_translation';
import useWindowSize from '../../hooks/use_window_resize';

const is_server = typeof window === 'undefined';

const Alert = () => {
	const { t } = useTranslation('component_alert');
	const windowSize = useWindowSize();

	const [currentIndex, setCurrentIndex] = useState(-1);
	const alert_messages = useMemo(() => {
		const messages = [];

		for (const key of ['t1', 't2', 't3']) {
			const tmp = t(key);
			if (!tmp || tmp.indexOf(key) !== -1) continue;
			messages.push(key);
		}

		return messages;
	}, [t]);

	const isMobile = useMemo(() => {
		return !is_server && windowSize?.width <= 1168;
	}, [windowSize]);

	useEffect(() => {
		if (currentIndex == -1) {
			setCurrentIndex(0);
		}

		if (!isMobile) return;

		const interval = setInterval(() => {
			setCurrentIndex((prevIndex) => (prevIndex + 1) % alert_messages.length);
		}, 5000); // 5000ms (5 seconds) delay between fades

		return () => {
			clearInterval(interval);
		};
	}, [alert_messages, currentIndex, isMobile]);

	if (!alert_messages || !alert_messages.length) {
		return <></>;
	}

	return (
		<div
			className="alert alert-top bg-dark border-0 text-white rounded-0 px-3"
			role="alert"
		>
			<div className="container text-dark d-flex align-items-center justify-content-between">
				{alert_messages.map((key, index) => (
					<div
						className={`alert-top-text text-white ${
							index === currentIndex ? 'visible' : 'hidden'
						}`}
						key={index}
					>
						<Trans i18nKey={key} t={t} />
					</div>
				))}
			</div>
		</div>
	);
};

export default Alert;
